import { LegalNoticePage } from '@/page-content/legal-notice';
export default LegalNoticePage;